import React, { Component } from 'react'

class TopIntro extends Component {
    render() {
        const project = this.props.project
        const newDate = new Date(project.endDate)

        // 날짜 변환
        const dueDateSec = newDate.getTime()

        const nowTime = new Date()
        nowTime.setHours(12)
        nowTime.setMinutes(0)
        nowTime.setSeconds(0)
        nowTime.setMilliseconds(0)
        const nowDateSec = nowTime.getTime()

        let dday = dueDateSec - nowDateSec
        dday = Math.floor(dday / (1000 * 60 * 60 * 24))

        if (dday < 0) {
            dday = 'D+' + Math.abs(dday)
        } else {
            dday = 'D-' + dday
        }

        return (
            <div className="intro_wrap">
                {project.thumbnailUrl && <img className="bg_img" src={project.thumbnailUrl} alt="bg" />}
                <div className="text_wrap">
                    <div className="common_wrap">
                        <div className="dday">{dday}</div>
                        <h1>
                            <span>{project.title}</span>
                        </h1>
                    </div>
                </div>
            </div>
        )
    }
}

export default TopIntro



// WEBPACK FOOTER //
// ./Src/Components/Dashboard/OwnerTopIntro.js